webpackJsonp([65],{

/***/ 1086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-sidebar',{attrs:{"title":'Editar compañia',"value":true,"width":524},on:{"close-modal":_vm.closeModal}},[_c('v-layout',{attrs:{"px-4":"","mt-3":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Dominio"},model:{value:(_vm.model.domain),callback:function ($$v) {_vm.$set(_vm.model, "domain", $$v)},expression:"model.domain"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"IdSales"},model:{value:(_vm.model.salesId),callback:function ($$v) {_vm.$set(_vm.model, "salesId", $$v)},expression:"model.salesId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-select',{staticClass:"body-1 mt-2",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"id","label":"Estado","items":_vm.status},model:{value:(_vm.model.status),callback:function ($$v) {_vm.$set(_vm.model, "status", $$v)},expression:"model.status"}})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"isLoading":false},on:{"accept-button-clicked":_vm.saveEdit,"cancel-button-clicked":_vm.closeModal}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_config_edit_synchronize_vue__ = __webpack_require__(859);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02cd7695_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_config_edit_synchronize_vue__ = __webpack_require__(1086);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_config_edit_synchronize_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02cd7695_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_config_edit_synchronize_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__ = __webpack_require__(149);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function closeModal() {
	this.goTo('page-config-synchronize-companies');
}

function created() {
	var row = JSON.parse(this.$route.query.data || '{}');
	var domain = row.domain,
	    status = row.status,
	    id = row.id,
	    salesId = row.salesId;

	this.id = id;
	this.model = { domain: domain, status: status, salesId: salesId };
}

function data() {
	return {
		status: [{
			id: 1,
			name: 'Registrado'
		}, {
			id: 2,
			name: 'Pendiente'
		}, {
			id: 3,
			name: 'Iniciado'
		}, {
			id: 4,
			name: 'Finalizado'
		}, {
			id: 5,
			name: 'Error'
		}],
		model: {
			status: null,
			domain: null,
			salesId: null
		},
		id: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-config-create',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__["default"]
	},
	created: created,
	data: data,
	methods: {
		closeModal: closeModal,
		saveEdit: function saveEdit() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var body;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								body = _this.model;
								_context.prev = 1;
								_context.next = 4;
								return _this.$httpCompany.patch('ext-companies/' + _this.id, body);

							case 4:
								_this.showNotification('Se actualizo correctamente la compañia', 'success');
								_this.closeModal();
								_context.next = 11;
								break;

							case 8:
								_context.prev = 8;
								_context.t0 = _context['catch'](1);

								_this.showNotification('No se pudo actualizar la companía', 'error');

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[1, 8]]);
			}))();
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/65.ec1cc8d0b8134e49f0d3.js